import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { useContent } from "../context/ContentContext";

export function Footer() {
  const { content } = useContent();
  const c = content?.contact || {};
  const socials = [
    { key: "instagram", Icon: Instagram },
    { key: "facebook", Icon: Facebook },
    { key: "youtube", Icon: Youtube },
  ];
  return (
    <footer className="relative border-t border-white/10 bg-[#080809] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <img src="/logo-kmr.jpg" alt="KMR Event" className="h-12 rounded-md mb-5" />
            <p className="text-sm text-muted-foreground leading-relaxed">
              La musique, l'ambiance et les partenaires qu'il faut pour donner vie à chaque événement.
            </p>
          </div>

          <div>
            <h4 className="font-serif text-xl mb-4 text-gold">Prestations</h4>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li><Link to="/musique-live" className="hover:text-gold transition-colors">Musique live</Link></li>
              <li><Link to="/dj" className="hover:text-gold transition-colors">DJing</Link></li>
              <li><Link to="/location-materiel" className="hover:text-gold transition-colors">Location de matériel</Link></li>
              <li><Link to="/services-partenaires" className="hover:text-gold transition-colors">Services partenaires</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-xl mb-4 text-gold">Informations</h4>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li><Link to="/galerie" className="hover:text-gold transition-colors">Galerie</Link></li>
              <li><Link to="/a-propos" className="hover:text-gold transition-colors">À propos</Link></li>
              <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
              <li><Link to="/devis" className="hover:text-gold transition-colors">Demander un devis</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-xl mb-4 text-gold">Contact</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center gap-2"><Mail size={16} className="text-gold" /> {c.email || "contact@kmrevent.com"}</li>
              <li className="flex items-center gap-2"><Phone size={16} className="text-gold" /> {c.phone || "À compléter"}</li>
              <li className="flex items-center gap-2"><MapPin size={16} className="text-gold" /> {c.zone || "Zone à préciser"}</li>
            </ul>
            <div className="flex gap-3 mt-5">
              {socials.map(({ key, Icon }) =>
                c[key] ? (
                  <a key={key} href={c[key]} target="_blank" rel="noopener noreferrer" className="glass p-2.5 rounded-full hover:text-gold transition-colors" aria-label={key}>
                    <Icon size={18} />
                  </a>
                ) : null
              )}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} KMR Event. Tous droits réservés.</p>
          <div className="flex gap-5">
            <Link to="/mentions-legales" className="hover:text-gold transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-gold transition-colors">Confidentialité</Link>
            <Link to="/cookies" className="hover:text-gold transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
